import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(_nuxtApp => {
  // vue3-openlayers компоненты регистрируются автоматически при импорте
  // Но нужно убедиться, что они доступны только на клиенте
  if (import.meta.client) {
    // Компоненты vue3-openlayers должны быть доступны глобально
    // Если это не работает, можно попробовать явный импорт
  }
});
